import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TchekService } from '../../service/tchek.service';
import { Tchek } from '../../model/tchek';
import { Tchekb, PicturesSelectedTchek } from '../../model/tchekb.model';

@Component({
  selector: 'app-preselection',
  templateUrl: './preselection.component.html',
  styleUrls: ['./preselection.component.less']
})
export class PreselectionComponent implements OnInit, OnChanges {
  @Input() tchekId: string;
  tchek: PicturesSelectedTchek

  constructor(private readonly _tchekService: TchekService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tchekId && changes.tchekId.currentValue) {
      this.onNewTchekId(changes.tchekId.currentValue);
    }
  }

  private async onNewTchekId(id: string) {
    this._tchekService.get(this.tchekId).then(tchek => {
      this._tchekService.picturesSelectedTchek(tchek).then(
        result => {
          this.tchek = result
          console.log("tchek", result);
        }
      )
    })
  }


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/element/preselection/preselection.component.ts